"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var NarrativeMap_vue_1 = __importDefault(require("@/components/maps/narrative-map/NarrativeMap.vue"));
//credit to @Bill Criswell for this filter
vue_1.default.filter('truncate', function (text, stop, clamp) {
    return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '');
});
var Narrative = /** @class */ (function (_super) {
    __extends(Narrative, _super);
    function Narrative() {
        var _a, _b, _c;
        var _this = _super.call(this) || this;
        _this.currentChapterIndex = 1;
        _this.currentChapter = (_b = (_a = _this.narrative) === null || _a === void 0 ? void 0 : _a.chapters[_this.currentChapterIndex - 1]) !== null && _b !== void 0 ? _b : null;
        _this.totalChapters = ((_c = _this.narrative) === null || _c === void 0 ? void 0 : _c.chapters.length) || 0;
        _this.modalReady = false;
        _this.showMap = false;
        _this.showDescription = false;
        return _this;
    }
    Narrative.prototype.pageChanged = function (page) {
        var _a, _b;
        this.currentChapter = (_b = (_a = this.narrative) === null || _a === void 0 ? void 0 : _a.chapters[page - 1]) !== null && _b !== void 0 ? _b : null;
    };
    Narrative.prototype.formatVideoURI = function (videoURI) {
        var url = new URL(videoURI);
        if (url.host.startsWith("www.youtube")) {
            return "https://www.youtube.com/embed/" + url.searchParams.get("v");
        }
        return videoURI;
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], Narrative.prototype, "narrative", void 0);
    Narrative = __decorate([
        vue_property_decorator_1.Component({
            name: "Narrative",
            components: {
                NarrativeMap: NarrativeMap_vue_1.default
            },
            filters: {},
        })
    ], Narrative);
    return Narrative;
}(vue_1.default));
exports.default = Narrative;
